<div class="trophy-grid">
  <div class="award" *ngFor="let award of userData.trophies; let i = index">
    <img
      src="{{ 'assets/images/leader_board/' + award.type + '_cup.png' }}"
      alt="{{ award.type + 'trophy' }}"
    />
    <span>{{ award.date }}</span>
  </div>
</div>
